export type TUserRole = 'Admin' | 'User' | 'Dealer' | 'Dev';

export const UserRole: Record<string, TUserRole> = {
    ADMIN: 'Admin',
    USER: 'User',
    DEALER: 'Dealer',
    DEV: 'Dev',
};
